/**
 * helper function for preventing circular entries while serializing an object using JSON.stringify
 * usage => JSON.stringify(data, getCircularReplacer());
 *
 * Cuts only back-edges. Tracking every value ever seen instead would delete the
 * second occurrence of a merely *shared* value: jsonapi-react resolves relationships
 * by object identity and AMS runs with `include_data_default = true`, so one resource
 * routinely hangs off several parents in a payload (a gig's brief items are also
 * linked from its campaign). Those used to serialize as `null`.
 */
const getCircularReplacer = () => {
  const ancestors: unknown[] = [];
  return function (this: unknown, key: string, value: unknown) {
    if (typeof value !== 'object' || value === null) {
      return value;
    }
    // `this` is the object `key` belongs to, so unwinding to it leaves `ancestors`
    // holding exactly the current path.
    while (ancestors.length > 0 && ancestors[ancestors.length - 1] !== this) {
      ancestors.pop();
    }
    if (ancestors.includes(value)) {
      return undefined;
    }
    ancestors.push(value);
    return value;
  };
};

export default getCircularReplacer;
